// src/routes/rolesRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Roles from '../pages/roles/Roles';
import CreateRoles from '../pages/roles/CreateRoles';
import EditRoles from '../pages/roles/EditRoles';
import ProtectedRoute from '../components/global/ProtectedRoute';

const rolesRoutes = (
    <>
        {/* Roles List */}
        <Route
            path="/roles"
            element={
                <ProtectedRoute requiredPermission="roles_list">
                    <Roles />
                </ProtectedRoute>
            }
        />

        {/* Create Role */}
        <Route
            path="/roles/create"
            element={
                <ProtectedRoute requiredPermission="roles_create">
                    <CreateRoles />
                </ProtectedRoute>
            }
        />

        {/* Edit Role */}
        <Route
            path="/roles/:id/edit"
            element={
                <ProtectedRoute requiredPermission="roles_edit">
                    <EditRoles />
                </ProtectedRoute>
            }
        />
    </>
);

export default rolesRoutes;